export const initAutocomplete = (setAutocomplete: () => Promise<void>) => {
	/**
	 * Coming from /quote the autocomplete works, but if you refresh flow id doesn't
	 * Using this tip from compallet help me solve the issue
	 */

	if (typeof google === 'undefined') {
		setTimeout(() => {
			if (typeof google === 'undefined') {
				return;
			} else {
				setAutocomplete();
			}
		}, 1000);
	}

	if (typeof google !== 'undefined') {
		setAutocomplete();
	}
};
